import React from 'react'

const RADIUS = 52
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

function ChatStatsDonut({ segments, total, size = 150 }) {
    let consumed = 0

    return (
        <div style={{ position: 'relative', width: size, height: size, flex: 'none' }}>
            <svg width={size} height={size} viewBox="0 0 120 120">
                <circle cx="60" cy="60" r={RADIUS} fill="none" stroke="#e4e3f0" strokeWidth="15" />
                {segments.map((segment) => {
                    const dash = (segment.percent / 100) * CIRCUMFERENCE
                    const rotation = -90 + (consumed / 100) * 360
                    consumed += segment.percent
                    return (
                        <circle
                            key={segment.key}
                            cx="60"
                            cy="60"
                            r={RADIUS}
                            fill="none"
                            stroke={segment.color}
                            strokeWidth="15"
                            strokeDasharray={`${dash} ${CIRCUMFERENCE}`}
                            transform={`rotate(${rotation} 60 60)`}
                        />
                    )
                })}
            </svg>
            <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: 28, fontWeight: 800, color: '#2d2b45', lineHeight: 1 }}>{total}</span>
                <span style={{ fontSize: 12, color: '#8e8fb4', marginTop: 2 }}>Chats</span>
            </div>
        </div>
    )
}

export default ChatStatsDonut
